// Round-trip URL search params <-> typed filter object for
// /management/recommendations. Used by the route's `validateSearch` and
// consumed via `useSearch` in the recommendation-settings table widget.

export const RECOMMENDATIONS_PAGE_SIZE = 20;

export type RecommendationsSearch = {
  page?: number;
};

export const validateRecommendationsSearch = (
  input: Record<string, unknown>
): RecommendationsSearch => ({
  page: typeof input.page === 'number' ? input.page : undefined,
});
